<iframe aria-label='HINDU college pharmacy' frameborder="0" style="height:1000px;width:100%;border:none;"
    src='https://data.odpay.in/odforms1/form/HINDUcourtroad/formperma/l_WQjBlxlHOcatEBUUEdJiPX6amDB9iTSEiwJ4IDe7E'></iframe>